import React from 'react';
import PropTypes from 'prop-types';
import { Tooltip } from 'recharts';
import ClrChartTooltip from './ClrChartTooltip';
import { CLR_TOOLTIP_PROPS } from './chartTooltipConfig';

function ClrRechartsTooltip({ formatter, cursor, clampToCard = false, ...rest }) {
  return (
    <Tooltip
      {...CLR_TOOLTIP_PROPS}
      cursor={cursor}
      content={<ClrChartTooltip formatter={formatter} clampToCard={clampToCard} />}
      {...rest}
    />
  );
}

ClrRechartsTooltip.propTypes = {
  formatter: PropTypes.func,
  cursor: PropTypes.oneOfType([PropTypes.bool, PropTypes.object]),
  clampToCard: PropTypes.bool,
};

export default ClrRechartsTooltip;
